import { render } from "./TinyPumperHealth.vue?vue&type=template&id=1c187a7c"
import script from "./TinyPumperHealth.vue?vue&type=script&lang=js"
export * from "./TinyPumperHealth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__